var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNavigate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.539,
    height: 34.5,
    viewBox: "0 0 34.539 34.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-navigate",
    transform: "translate(-0.015 -0.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0.015 0.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "explore"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M29.458,5.058a17.156,17.156,0,1,0,5.1,12.2,17.25,17.25,0,0,0-5.1-12.2Zm-3.826,5.715L21.649,20.881a1.486,1.486,0,0,1-.831.831L10.769,25.642a1.556,1.556,0,0,1-.532.1A1.486,1.486,0,0,1,9.2,25.315a1.468,1.468,0,0,1-.328-1.568L12.8,13.674a1.451,1.451,0,0,1,.831-.8l10.1-3.966a1.468,1.468,0,0,1,1.568.328,1.451,1.451,0,0,1,.328,1.538Z",
    transform: "translate(-0.015 -0.01)",
    fill: "#7fc15f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M21.89,30.8l6.37-2.492,2.509-6.388-6.393,2.5Z",
    transform: "translate(-9.094 -9.104)",
    fill: "#7fc15f"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNavigate);
export default __webpack_public_path__ + "static/media/icon-navigate.9980f026b93d194533ad366d63887cbf.svg";
export { ForwardRef as ReactComponent };